import { get } from 'lodash';
import { useMediaProps } from '@zapier/responsive-utils';
import { Size } from '@zapier/design-system-revenue/src/types';

export const usePricingPageSize = (): Size => {
  const mediaProps = useMediaProps({
    all: {
      size: 'small',
    },
    ['(min-width: 784px) and (max-width: 1279px)']: {
      size: 'medium',
    },
    ['(min-width: 1280px)']: {
      size: 'large',
    },
  });

  return get(mediaProps, 'size');
};
